<template>
  <div class="customer-list">
    <mescroll-vue
      ref="mescroll"
      :down="mescrollDown"
      :up="mescrollUp"
      class="scroll"
      @init="mescrollInit"
    >
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          v-for="(item, index) in list"
          :name="index"
          :key="index"
          :title="item.awardName"
        >
          <div class="content">
            <div class="list">
              <span class="list-left">奖品类型</span>
              <span class="list-right">{{ item.awardTypeExcel }}</span>
            </div>
            <div class="list">
              <span class="list-left">中奖概率</span>
              <span class="list-right">{{ item.winProbabilityExcel }}</span>
            </div>
            <div class="list">
              <span class="list-left">总数量</span>
              <span class="list-right">{{ item.awardNumber }}</span>
            </div>
            <div class="list">
              <span class="list-left">已发放量</span>
              <span class="list-right">{{ item.sendCount }}</span>
            </div>
            <div class="list">
              <span class="list-left">状态</span>
              <span class="list-right">{{ item.statusExcel }}</span>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </mescroll-vue>
  </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
  components: {
    MescrollVue,
  },
  computed: {
    activityId() {
      return this.$route.query.activityId
    }
  },
  data() {
    return {
      mescroll: null,
      mescrollDown: {
        callback: this.init
      },
      mescrollUp: {
        callback: this.getList,
        page: {
          num: 1,
          size: 10
        },
        htmlNodata: '<p class="upwarp-nodata">-- 没有更多数据了 --</p>',
        noMoreSize: 1,
        auto: true
      },
      activeName: "1",
      list: [],
    };
  },
  methods: {
    init() {
      this.list = []
      // 下拉刷新的回调; 默认重置上拉加载列表为第一页
      this.mescroll.resetUpScroll()
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll
    },
    getList(page, mescroll) {
      const params = this.$route.query
      this.$api.luckDraw.getActivityAwards({
        filterData: {...params},
        pageNum: page.num,
        pageSize: page.size,
      })
        .then(({data}) => {
          if (data.list) {
            this.list.push(...data.list);
            this.pageNum = data.pageNum + 1;
            mescroll.endSuccess(this.list.length, data.hasNextPage)
          }
        })
    },
  },
  filters: {
  }
};
</script>
<style lang="stylus" scoped>
.customer-list {
  height: 100%;
  .title {
    display: flex;
    justify-content: space-between;
    color: #333333;
    font-size: 16px;
  }
  .content {
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 10px 0;
      color: #999999;
      font-size: 14px;
      .list-right {
        position relative
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 230px;
        flex-wrap: wrap;
        color: #333333;
      }
    }
  }
}
</style>
